import { render, staticRenderFns } from "./satisiadefatura.vue?vue&type=template&id=30e391d4&"
import script from "./satisiadefatura.vue?vue&type=script&lang=js&"
export * from "./satisiadefatura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports